import { LSError } from '../util/LSError.interface';

export class SubmitAnswersError extends Error implements LSError {
  message: string;
  title: string;

  constructor() {
    super();
    this.title = 'Submit Answers Error';
    this.message = 'There was an error submitting your answers, please contact support if the error persists';
  }
}
